export const RATVIEW_CELL_CARRIER_OPTIONS = ['AT&T', 'Sprint', 'T-Mobile', 'Verizon'];

export const reviewStatuses = {
  flagged: {
    value: 'flagged',
    display: 'Pending Review',
  },
  approved: {
    value: 'approved',
    display: 'Active',
  },
  denied: {
    value: 'denied',
    display: 'Denied',
  },
  unprocessed: {
    value: 'unprocessed',
    display: 'Pending Review',
  },
};

export const automatedReviewActorType = 'automated_process';
export const anonymousExternalUserReviewActorType = 'anonymous_external_user';
export const externalUserReviewActorType = 'authenticated_external_user';

export const flagReasons = {
  explicit: {
    value: 'Explicit',
    display: 'Inappropriate language and/or sentiment',
  },
  political: {
    value: 'Political',
    display: 'Political sentiment',
  },
  pii: {
    value: 'PII',
    display: 'Disclosed personal information',
  },
  other: {
    value: 'Other',
    display: 'Other',
  },
};

export const MODERATION_PAGE_SIZE = 10;

export const REVIEW_SORT_KEYS = {
  MOST_RECENT: 'Most Recent',
  MOST_HELPFUL: 'Most Helpful',
  HIGHEST_RATING: 'Highest Rating',
  LOWEST_RATING: 'Lowest Rating',
};
